import api from "../api";

class sendEmailService {
async create(data) {
    return api.post("/DashBoard/sendEmail", data);
  }
}

export default new sendEmailService();